///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import IReportFloorLocation = Meevo.Plugins.Reports.IReportFloorLocation;

    export class ReportFloorLocationsCollection extends SmartMoverApiCollection<IReportFloorLocation> implements IApiCollection<IReportFloorLocation> {

        protected get url() {
            return 'report/FloorLocation';
        }


        constructor(connectedModel: ModelValueType[], items: IReportFloorLocation[] = [], options: ICollectionOptions<IReportFloorLocation> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                'branchId': null,
                'objectStateEnumList': [ObjectStateEnum.Active],
                'displayName': null,
                'fieldOrderBy': 'DisplayName',
                'orderAscDesc': 'Ascending'
            });
        }
    }

}
